import React from 'react';
import classNames from 'classnames';
import { Badge } from 'react-bootstrap';
import SimpleQuoteBadge from '../SimpleQuoteBadge';
import ClickToCopy from '../../ClickToCopy';

const VehicleListItem = ({ vehicle = {}, className, quote = {}, onClick }) => {
  const cName = classNames('vehicle-card-wrapper', className);

  const excess = vehicle.count - 1;

  return (
    <div className={cName}>
      <div className="vehicle-card" onClick={onClick}>
        {excess > 0 && (
          <div className="vehicle-warning">Unit assigned to {excess} other quote{excess > 1 ? 's' : ''}</div>
        )}
        <div className="vehicle-toolbar">
          <h5 className="mb-1">
            <SimpleQuoteBadge quote={quote} />
          </h5>
        </div>
        <div className="vehicle-details">
          <div>
            <Badge style={{ border: '1px solid #CCC', backgroundColor: '#fafafa', padding: '5px', lineHeight: '13px' }}>
              {quote.vehicleId}
            </Badge>
          </div>
          <div style={{ fontSize: '11px', paddingTop: '5px' }}>
            {vehicle.Year} {vehicle.Make} {vehicle.Model}
          </div>
          <div>
            <ClickToCopy>{vehicle.VIN}</ClickToCopy>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleListItem;
